import { render, staticRenderFns } from "./ActiveCall.vue?vue&type=template&id=6b4fe55b"
import script from "./ActiveCall.vue?vue&type=script&lang=js"
export * from "./ActiveCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports